import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getDealCloudCrmSettings, saveDealCloudCrmSettings} from 'src/openapi/admin/apis/DealcloudControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {DealcloudSettings} from 'src/openapi/admin/models/DealcloudSettings';

type Props = {
    accountId: number,
};

export const useDealCloudCredentials = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getDealCloudCrmSettings({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback((dealcloudSettings: DealcloudSettings) => apiDispatch(
        saveDealCloudCrmSettings({
            accountId,
            dealcloudSettings,
        }),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {value: ''},
    });
};
